<template>
    <div class="change">
        <el-dialog title="请确认以下核心商品机制的变更" width="30%" :visible.sync="dialogCDetalisVisible">
            <div class="tipsBox">
                <tips-box></tips-box>
            </div>
            <div class="product_box">
                <product-box :row="row" :tabName="tabName"></product-box>
            </div>
            <div class="user_info_box mt-10">
                <user-info-box  :row="row"></user-info-box>
            </div>
            <div class="flex mt-20">
                <div class="table">
                    <div class="tr flex font-bold yx-color-text-primary">
                        <p class="th">变更项目</p>
                        <p class="th">变更前</p>
                        <p class="th third">变更后</p>
                    </div>
                    <div class="tr flex">
                        <p>直播价</p>
                        <p>{{ before_data.live_price }}</p>
                        <p class="third">{{ row.live_price }}</p>
                    </div>
                    <div class="tr flex">
                        <p>佣金率</p>
                        <p>{{ before_data.commission_rate }}<span v-if="before_data.commission_rate">%</span></p>
                        <p class="third">{{ row.commission_rate }}<span v-if="before_data.commission_rate">%</span></p>
                    </div>
                    <div class="tr flex">
                        <p>规格</p>
                        <p>{{ before_data.spec }}</p>
                        <p class="third">{{ row.spec }}</p>
                    </div>
                    <div class="tr flex">
                        <p>赠品</p>
                        <p>{{ before_data.gifts }}</p>
                        <p class="third">{{ row.gifts }}</p>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogCDetalisVisible = false">取 消</el-button>
                <el-button type="primary" @click="changeDConfirm">确认变更</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import productBox from '@/components/common/productBox';
import userInfoBox from '@/components/common/userInfoBox';
import tipsBox from '@/components/common/tipsBox';
import {  affirmChange } from '@/api/cooperationProgress';
export default {
    name: 'change',
    components: {
        productBox,
        userInfoBox,
        tipsBox
    },
    data() {
        return {
            dialogCDetalisVisible: false,
            row: {},
            tabName: '',
            before_data: {}
        }
    },
    methods: {
        initCDhange(row, tabName) {
            this.row = row
            this.before_data = row.before_data
            this.tabName = tabName
            this.dialogCDetalisVisible = true
        },
        async changeDConfirm() {
            const {code} = await affirmChange({cooperate_id: this.row.cooperate_id})
            if(code == 0) {
                this.$message.success('操作成功')
                this.$emit('refreshList')
                this.dialogCDetalisVisible = false
            }
        }
    }
}
</script>
<style lang="less" scoped>
.table {
    margin: 0 auto;
}
.table p{
    width: 121px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #ddd;
    border-left: 1px solid #ddd;
}
.th{
    border-top: 1px solid #ddd;
}
.third {
    border-right: 1px solid #ddd;
}
</style>